export enum StorageDataKeys {
  HAS_SEEN_NEW_PRODUCT = 'has_seen_new_product',
}
